var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-root"}},[_c('router-view',{key:_vm.topRouteKey}),_c('LoginModal'),_c('ProfileModal'),_c('UserInfoModals'),_c('MemberMessagePopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }